import { axios } from '@/services/axios';

const updatePlatformNumber = async ({ formData, scope }) => {
    const res = await axios.put('/PlatformNumber', formData, {
        headers: {
            'X-RequestScope': scope,
        },
    });
    return res.data;
};

export default updatePlatformNumber;
